module.exports = __webpack_public_path__ + "static/img/05.7e5f5dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/01/05.jpg
// module id = sWVF
// module chunks = 0